import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { showErrorToast, showSuccessToast } from '../../../components/atoms/Utlis/Toast';
import { ExtraState } from '../../Slice/Dashboard/ExtraSlice';
import { getEventFormTokenAPI, submitEventFormAPI } from '../../ApiCalls/Dashboard/EventAPI';
import { trackClarityEvent } from '../../../analytics/ClarityAnalytics';
import { CLARITY_EVENTS } from '../../../analytics/EventTypes';

export const ExtraReducer = (builder: ActionReducerMapBuilder<ExtraState>) => {
    builder.addCase(getEventFormTokenAPI.pending, (state) => {
        state.loading = true;
        state.isError = false;
        state.success = false;
        state.error = {};
    })
        .addCase(getEventFormTokenAPI.fulfilled, (state, action: PayloadAction<string>) => {
            state.loading = false;
            // // console.log("changing token", action.payload)
            state.eventFromToken = action.payload;

            // state.Events = action.payload;
        })
        .addCase(getEventFormTokenAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(submitEventFormAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(submitEventFormAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            trackClarityEvent(CLARITY_EVENTS.CUSTOMER_EVENT_SUBMITTED, {
                customer_name: action.meta?.arg?.customer_name,
                event_name: action.meta?.arg?.event_name,
                phone_number: action.meta?.arg?.phone_number,
                sub_events_count: action.meta?.arg?.sub_events?.length || 0,
            })
            // state.eventFromToken = action.payload;

            // state.Events = action.payload;
        })
        .addCase(submitEventFormAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
};